import React, { useState } from 'react';
import { IoLogOutOutline } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { ReactComponent as EscPlanSVG } from '../../../assets/icons/escape-plan.svg';
import { Button, Typography } from '../../../designComponents';
import { useResponsive } from '../../../hooks/useResponsive';
import { LOG_OUT_ROUTE } from '../../../routes/routePaths';
import { flexStart } from '../../../style/reusableStyle';
import {
  IndividualStep,
  LogoInfoWrapper,
  OnBoardingSidebarStyled,
  StepsContainer,
} from './onboardsidebar.style';

const LinkStyled = styled(Link)`
  ${flexStart};
  gap: 14px;
  text-decoration: none;
  padding: 10px;
  border-radius: 6px;

  & svg {
    height: 24px;
    width: 24px;
    color: ${({ theme }) => theme.colors.normalText};
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightBackground};
  }
`;

const steps = [
  {
    step: 1,
    label: 'Personal Information',
    desc: 'Enter your personal information to get closer to ESCAPE PLAN',
  },
  {
    step: 2,
    label: 'Upload Profile Picture',
    desc: 'Upload your profile picture',
  },
  {
    step: 3,
    label: 'Contact Information',
    desc: 'Enter your contact information to get closer to ESCAPE PLAN',
  },
  {
    step: 4,
    label: 'Company Details',
    desc: 'Enter your company details to get closer to ESCAPE PLAN',
  },
  {
    step: 5,
    label: 'Payment Method',
    desc: 'Enter your payment method to get closer to ESCAPE PLAN',
  },
  // {
  //   step: 5,
  //   label: 'Verification Code',
  //   desc: 'Enter your verification code  to verify your email and get closer to ESCAPE PLAN',
  // },
];

type Props = {
  currentSteps: number;
};

const OnBoardingSidebar = ({ currentSteps }: Props) => {
  const [showAllSteps, setShowAllSteps] = useState(false);

  const { isTablet } = useResponsive();

  const renderIndividualStep = (step: (typeof steps)[0]) => {
    return (
      <IndividualStep
        key={step.label}
        $status={
          currentSteps > step.step
            ? 'Done'
            : currentSteps === step.step
              ? 'Active'
              : 'Disabled'
        }
      >
        <div className="step-number">{step.step}</div>
        <div className="step-label">{step.label}</div>
      </IndividualStep>
    );
  };

  return (
    <OnBoardingSidebarStyled>
      <LogoInfoWrapper>
        <div className="logo-info">
          <Typography fontColor="dark" strong>
            Evacuation Plans
          </Typography>
          <Typography variant="caption">SaaS Application</Typography>
        </div>
        <EscPlanSVG className="esc-logo" />
      </LogoInfoWrapper>

      <StepsContainer>
        <Typography strong variant="title" className="step-number">
          {currentSteps > steps.length ? 'Completed' : `Step ${currentSteps}`}
        </Typography>
        <Typography className="step-desc">
          {steps[currentSteps - 1]?.desc}
        </Typography>
        {!isTablet && (
          <Button
            variant="primary"
            size="xs"
            onClick={() => setShowAllSteps((prev) => !prev)}
            style={{ marginBottom: '18px' }}
          >
            {showAllSteps ? 'Hide ' : 'Show '} All Steps
          </Button>
        )}

        {isTablet ? (
          <div className="steps-wrapper">
            {steps.map((step) => renderIndividualStep(step))}
          </div>
        ) : (
          showAllSteps && (
            <div className="steps-wrapper">
              {steps.map((step) => renderIndividualStep(step))}
            </div>
          )
        )}
        <LinkStyled to={LOG_OUT_ROUTE}>
          <IoLogOutOutline />
          <Typography>Logout</Typography>
        </LinkStyled>
      </StepsContainer>
    </OnBoardingSidebarStyled>
  );
};

export default OnBoardingSidebar;
